/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

/** Event handler that exposes the target element's value as a boolean.
 * Taken from https://github.com/palantir/blueprint/blob/fd3833e0ced0befbd5819e1690404cfd7705a084/packages/docs-theme/src/components/baseExample.tsx#L121
 */
export default function handleBooleanChange(
    handler: (checked: boolean) => void
) {
    return (event: React.FormEvent<HTMLElement>) =>
        handler((event.target as HTMLInputElement).checked)
}
